(function (angular) {
    'use strict';

    /**
     * Requires directives:
     *   * has-any-authority-or-state
     *   * uib-dropdown-toggle
     */
    angular
        .module('app')
        .component('miMenuBidiso', {
            bindings: {
                menu: '<',
                navCollapsed: '<',
                lateral: '<'
            },
            templateUrl: 'app/components/menu/menu-bidiso.html',
            /* @ngInject */
            controller: function ($state) {
                var vm = this;

                vm.isMac = false;
                vm.isChrome = false;

                vm.checkActiveStates = function (activeStates) {
                    var active = false;
                    if (activeStates) {
                        var states = activeStates.replace(/\s+/g, '').split(',');
                        states.forEach(function (state) {
                            if ($state.includes(state) || state === 'lugares') {
                                active = true;
                            }
                        });
                    }
                    return active;
                };

                // Comprueba el sistema operativo y el navegador que se usa
                // para seleccionar los estilos empleados
                function checkOS() {
                    if (navigator.userAgent.includes("Mac")) {
                        vm.isMac = true;
                        vm.isChrome = navigator.userAgent.includes("Chrome/");
                    } else {
                        vm.isMac = false;
                        vm.isChrome = navigator.userAgent.includes("Chrome/") && !navigator.userAgent.includes("Edg/");
                    }
                }
                checkOS();
            }
        });
})(angular);
